const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

const path = "../images/gallery/hair/";
const photoLink = (id) => `${path}${id}.jpg`;

const Photos = [
    { id: "1", width: 689, height: 732 },
    { id: "2", width: 1200, height: 1600 },
    { id: "3", width: 1200, height: 1600 },
    { id: "4", width: 1200, height: 1600 },
    { id: "5", width: 1122, height: 1600 },
    { id: "6", width: 1200, height: 1600 },
    { id: "7", width: 1280, height: 1600 },
    { id: "8", width: 1200, height: 1600 },
    { id: "9", width: 1067, height: 1600 },
    { id: "10", width: 1203, height: 1600 },
    { id: "11", width: 1200, height: 1600 },
    { id: "12", width: 1200, height: 1600 },
    { id: "13", width: 1170, height: 768 },
    { id: "14", width: 1170, height: 774 },
    { id: "15", width: 1200, height: 1600 },
    { id: "16", width: 1040, height: 1600 },
    { id: "17", width: 1067, height: 1599 },
    { id: "18", width: 1067, height: 1600 },
    { id: "19", width: 1401, height: 1600 },
    { id: "20", width: 1142, height: 1600 },
];

const hairPhotos = Photos.map((photo) => ({
    src: photoLink(photo.id),
    width: photo.width,
    height: photo.height,
    images: breakpoints.map((breakpoint) => {
        const height = Math.round((photo.height / photo.width) * breakpoint);
        return {
            src: photoLink(photo.id),
            width: breakpoint,
            height,
        };
    }),
}));

export default hairPhotos;